/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import useFetch from 'use-http';
import { useHistory } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardHeader,
  CardFooter,
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Heading } from '@/components/ui/shared/heading';
import { Download } from 'lucide-react';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { SlashIcon } from 'lucide-react';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { useUserState } from '@/components/context/UserContext';
import { downloadAmisPdf } from '@/v2/utils/downloadAmisPdf';

const PrescriptionDetails = () => {
  const history = useHistory();
  const { get: getFile, response: getFileResponse } = useFetch(
    '/UserAccount/DownloadAmisFile',
  );
  const prescription = history.location?.state?.data;
  const userState = useUserState();

  const formatDateWithoutConversion = (date) => {
    if (!date) {
      return '-';
    }

    const value = String(date);
    const datePart = value.substring(0, 10);
    const timePart = value.substring(11, 16);

    if (!datePart) {
      return '-';
    }

    if (!timePart || timePart === '00:00') {
      return datePart;
    }

    return `${datePart} ${timePart}`;
  };

  const formatDateOnlyWithoutConversion = (date) => {
    if (!date) {
      return '-';
    }

    return String(date).substring(0, 10);
  };

  const handleFileDownload = async () => {
    await downloadAmisPdf({
      getFile,
      response: getFileResponse,
      query: `?fileType=${prescription.file.type}&fileGuid=${prescription.file.guid}&category=Prescription&espbiEsi=${userState.espbiEsi}`,
      fileName:
        trimFileName(prescription.name) +
        ' ' +
        formatDateOnlyWithoutConversion(prescription.dateAsserted),
    });
  };

  const trimFileName = (fileName) => {
    if (fileName.length > 190) {
      return fileName.substring(0, fileName.length - 18) + '...';
    }

    return fileName;
  };

  if (!prescription) {
    return null;
  }

  return (
    <div className="space-y-5">
      <Breadcrumb className={'px-4'}>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/userAccount/prescriptions">Receptai</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator>
            <SlashIcon />
          </BreadcrumbSeparator>
          <BreadcrumbItem>
            <BreadcrumbPage>{prescription.name}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Card>
        <CardHeader>
          <Heading variant="userAccountDetailsTitle">
            {prescription.name}
          </Heading>
        </CardHeader>

        <CardContent className={'space-y-2'}>
          <div>
            <span>Data: </span>
            <span>
              {formatDateWithoutConversion(prescription.dateAsserted)}
            </span>
          </div>

          <div>
            <span>Pavadinimas: </span>
            <span>{prescription.name}</span>
          </div>

          <div>
            <span>Diagnozė: </span>
            <span>{prescription.reason}</span>
          </div>

          <div>
            <span>Kompensacijos rūšis: </span>
            <span>
              {prescription.coverage === null || prescription.coverage === ''
                ? 'Nekompensuojama'
                : prescription.coverage}
            </span>
          </div>

          <div>
            <span>Dozavimo rekomendacijos: </span>
            {prescription.dosage ? (
              <span>{prescription.dosage}</span>
            ) : (
              <span>-</span>
            )}
          </div>

          <div>
            <span>Galioja nuo: </span>
            <span>
              {formatDateOnlyWithoutConversion(prescription.effectiveStartDate)}
            </span>
          </div>

          <div>
            <span>Galioja iki: </span>
            <span>
              {formatDateWithoutConversion(prescription.effectiveEndDate)}
            </span>
          </div>
        </CardContent>

        <CardFooter />
      </Card>

      {prescription.file?.guid && (
        <Card>
          <CardHeader>
            <Heading variant="userAccountDetailsTitle">Dokumentai</Heading>
          </CardHeader>

          <CardContent>
            <Button variant={'light'} onClick={handleFileDownload}>
              <Download />
              Atsisiųsti PDF
            </Button>
          </CardContent>

          <CardFooter />
        </Card>
      )}
    </div>
  );
};

export default PrescriptionDetails;
